import { type IProjectSaleItem } from "@/interfaces/api/project-sale-item.interface"
import { BaseModel } from "@/models/base.model"

export class ProjectSaleItem extends BaseModel implements IProjectSaleItem {
  public static className = "ProjectSaleItem" // Used for socket communication.
  public static verboseName = "projectverkoopafspraak"

  saleItem: string
  project: string

  unitPrice?: string
  surchargeModifier?: string

  constructor(projectSaleItem: IProjectSaleItem) {
    super(projectSaleItem)

    this.saleItem = projectSaleItem.saleItem
    this.project = projectSaleItem.project

    this.unitPrice = projectSaleItem.unitPrice
    this.surchargeModifier = projectSaleItem.surchargeModifier
  }
}
